import { Component, ViewChild } from "@angular/core";
import { Nav, Platform, AlertController } from "ionic-angular";
import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";
import { Idle, DEFAULT_INTERRUPTSOURCES } from "@ng-idle/core";
import { Keepalive } from "@ng-idle/keepalive";
import { InterceptorAuthProvider } from "../providers/interceptor-auth/interceptor-auth";
import { IpAddressProvider } from "../providers/utility/ip-address/ip-address";
import { FacilityServicesProvider } from "../providers/facility-service/facility-service";

@Component({
  templateUrl: "app.html",
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  // rootPage: any = LoginPage;
  rootPage: any = "";
  rootParams: any = {};
  pages: Array<{ title: string; component: any }>;
  idleState = "Not started.";
  timedOut = false;
  lastPing?: Date = null;
  alert: any;
  dismissAlert: boolean = false;
  boundEventCallBack: any;
  showBlur: boolean = false;

  constructor(
    public authService: InterceptorAuthProvider,
    public alertCtrl: AlertController,
    private idle: Idle,
    platform: Platform,
    statusBar: StatusBar,
    splashScreen: SplashScreen,
    public ipAddress: IpAddressProvider,
    public facilityServiceProvider: FacilityServicesProvider
  ) {
    platform.ready().then(() => {
      // statusBar.styleDefault();
      // splashScreen.hide();
      //this.setToken()
      // this.setRootPage()
    });

    this.pages = [
      // { title: 'Dashboard', component: 'DashboardPage',  },
      { title: "Members", component: "MemberSearchPage" },
      { title: "Trips", component: "TripsPage" },
      // { title: 'Marketplace', component: 'MarketplacePage' }
    ];

    // sets an idle timeout of 5 seconds, for testing purposes.
    idle.setIdle(120);
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    idle.setTimeout(1800);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.idleState = "No longer idle.";
    });

    idle.onTimeout.subscribe(() => {
      this.reset();
      if (sessionStorage.getItem("linkInactive") != "false") {
        this.idleState = "Timed out!";
        this.timedOut = true;
        this.authService.logout();
        this.dismissAlert = false;
      }
    });

    idle.onIdleStart.subscribe(() => {
      if (sessionStorage.getItem("linkInactive") != "false") {
        this.idleState = "You've gone idle!";
        this.presentAlert(false);
        this.showBlur = true;
        this.createListeners();
      }
    });

    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = "You will time out in " + countdown + " seconds!";
    });

    // this.reset();

    // this.ipAddress.getIPAddress().subscribe(res => {
    //   console.log(res, 'logging ip result')
    // })

    // Ask other tabs for session storage (this is ONLY to trigger event)
  }

  async ngOnInit() {
    await setTimeout(async () => {
      await this.authorize();
    });
  }

  reset() {
    this.idle.watch();
    this.idleState = "Started.";
    this.timedOut = false;
  }

  presentAlert(e) {
    this.alert = this.alertCtrl.create({
      message: `<p>Your session is paused due to inactivity.</p>
      <p>Move your cursor or click anywhere to resume.</p>`,
      buttons: [
        {
          text: "End Session",
          handler: () => {
            this.authService.logout();
            this.dismissAlert = false;
          },
        },
        {
          text: "Continue",
          role: "cancel",
          handler: () => {
            this.dismissAlert = false;
          },
        },
      ],
    });
    this.alert.present();
  }

  openPage(page) {
    if (page)
      this.nav.push(
        page.component,
        {},
        {
          animate: false,
        }
      );
  }

  async authorize() {
    localStorage.setItem("getSessionStorage", "test");
    const isAuthenticated = await this.authService.isAuthenticated();

    if (isAuthenticated) {
      this.initApp();
    } else {
      this.authService.signIn();
    }
  }

  initApp() {
    const tokenResult = this.authService.getLinkTokenResult();
    console.log(
      "app.component.ts initApp() logging token results",
      tokenResult
    );
    this.authService.setFacilityName(tokenResult);

    const currentPageHash = window.location.hash;
    // Reset root only if no route is defined by the url in the browser
    // Refresh will stay on the same page
    if (!currentPageHash || currentPageHash.startsWith("#/redirect")) {
      const { rootPage, rootParams } =
        this.authService.getRootPageInfo(tokenResult);
      this.rootPage = rootPage;

      this.nav.setRoot(this.rootPage, rootParams);
    }
  }

  createListeners() {
    this.boundEventCallBack = this.handleEvent.bind(this);
    document.addEventListener("mousemove", this.boundEventCallBack);
  }

  removeListeners() {
    this.showBlur = false;
    this.reset();
    document.removeEventListener("mousemove", this.boundEventCallBack);
  }

  handleEvent(e) {
    if (
      this.alert != undefined &&
      this.alert.instance != null &&
      this.alert.instance.enabled == true
    ) {
      this.alert.dismiss();
    }
    this.removeListeners();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts